import {Injectable} from '@angular/core';
import {Table} from "primeng/table";
import {TreeTable} from "primeng/treetable";

@Injectable({
  providedIn: 'root'
})
export class PrimeNgSupportService {

  constructor() {
  }


  push<T>(objArray: Array<T>, obj: T): Array<T> {
    let tempArray = objArray ? objArray : new Array<T>();
    return [...tempArray, obj];
  }

  unshift<T>(objArray: Array<T>, obj: T): Array<T> {
    let tempArray = objArray ? objArray : new Array<T>();
    return [obj, ...tempArray];
  }

  replaceByIndex<T>(objArray: Array<T>, obj: T, index: number): Array<T> {
    let tempArray = objArray ? objArray : new Array<T>();
    if (index > -1 && index < tempArray.length) {
      tempArray[index] = obj;
    }
    return [...tempArray];
  }

  replaceById<T>(objArray: Array<T>, obj: T): Array<T> {
    let tempArray = objArray ? objArray : new Array<T>();
    const index = tempArray.findIndex(o => o['id'] == obj['id']);
    if (index >= 0) {
      tempArray[index] = obj;
    }
    return [...tempArray];
  }

  replaceByObj<T>(objArray: Array<T>, obj: T, objToReplace: T): Array<T> {
    let tempArray = objArray ? objArray : new Array<T>();
    const index = tempArray.findIndex(o => o == objToReplace);
    if (index >= 0) {
      tempArray[index] = obj;
    }
    return [...tempArray];
  }

  deleteByIndex<T>(objArray: Array<T>, index: number): Array<T> {
    let tempArray = objArray ? objArray : new Array<T>();
    if (index > -1 && index < tempArray.length) {
      tempArray.splice(index, 1);
    }
    return [...tempArray];
  }

  deleteById<T>(objArray: Array<T>, id: number): Array<T> {
    let tempArray = objArray ? objArray : new Array<T>();
    return tempArray.filter(o => o['id'] != id);
  }

  deleteByObj<T>(objArray: Array<T>, obj: T): Array<T> {
    let tempArray = objArray ? objArray : new Array<T>();
    return tempArray.filter(o => o != obj);
  }

  resetTableFilter(dt: Table | TreeTable, searchElementId: string) {
    let searchInput = <HTMLInputElement>document.getElementById(searchElementId);
    searchInput.value = '';
    dt.filterGlobal(null, 'contains');
  }
}
